import { useGateValue } from '@statsig/react-bindings'
import { FeatureGates } from 'lib/statsig/feature_gates'
import { useLedShifts } from 'queries/shift'
import { Box, Carousel, Heading, Pluralize } from 'ui'
import { useShiftDetail } from '../useShiftDetail'
import { LinkedShiftCard } from './LinkedShiftCard'

export const ShiftDetailLinkedShifts = () => {
  const { companyId, shift } = useShiftDetail()
  const isW2LeadPositionsEnabled = useGateValue(
    FeatureGates.EnableW2LeadPositions
  )

  const { data: ledShifts = [] } = useLedShifts(
    { companyId, shiftId: shift?.id },
    { enabled: isW2LeadPositionsEnabled }
  )

  if (!isW2LeadPositionsEnabled || ledShifts.length === 0) {
    return null
  }

  return (
    <Box mb={2}>
      <Heading level={2} fontWeight={2}>
        Linked{' '}
        <Pluralize
          hideCount
          count={ledShifts.length}
          oneText="Shift"
          manyText="Shifts"
        />
      </Heading>
      <Carousel mx={-2} py={3} cardsToShow={[1, 2, 2, 2, 3]} gutter={2}>
        {ledShifts.map((ledShift) => (
          <LinkedShiftCard key={ledShift.id} shift={ledShift} />
        ))}
      </Carousel>
    </Box>
  )
}
